import { FakeBase } from "./base.fakes";
import { FakeDevelopment } from "./development.fakes";

function useFakes() {
    if (import.meta.env.MODE === "production" || import.meta.env.SSR) {
        return new FakeBase();
    } else {
        return new FakeDevelopment();
    }
}

export const fakes = useFakes();
